/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OTPAttestationData
 */
export interface OTPAttestationData {
    /**
     * 
     * @type {string}
     * @memberof OTPAttestationData
     */
    otp?: string;
}

/**
 * Check if a given object implements the OTPAttestationData interface.
 */
export function instanceOfOTPAttestationData(value: object): value is OTPAttestationData {
    return true;
}

export function OTPAttestationDataFromJSON(json: any): OTPAttestationData {
    return OTPAttestationDataFromJSONTyped(json, false);
}

export function OTPAttestationDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): OTPAttestationData {
    if (json == null) {
        return json;
    }
    return {
        
        'otp': json['otp'] == null ? undefined : json['otp'],
    };
}

export function OTPAttestationDataToJSON(json: any): OTPAttestationData {
    return OTPAttestationDataToJSONTyped(json, false);
}

export function OTPAttestationDataToJSONTyped(value?: OTPAttestationData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'otp': value['otp'],
    };
}

